import { Pipe, PipeTransform } from "@angular/core";
import { VehicleViewModel } from "src/domain/client";

@Pipe({
  name: "vehicle",
  pure: true,
})
export class VehiclePipe implements PipeTransform {
  transform(vehicle: VehicleViewModel): string {
    if (vehicle.licensePlate) {
      return vehicle.licensePlate;
    }

    if (vehicle.displayName && vehicle.year) {
      return `${vehicle.displayName}, ${vehicle.year}`;
    }

    return "";
  }
}
